<template>
  <div class="member-level-container">
    <!-- 会员等级列表 -->
    <div class="table-section">
      <SchemaTablePage
        layout-mode="tab"
        ref="tablePageRef"
        :columns="tableColumns"
        :default-query="defaultQuery"
        :request="request"
        :build-params="buildParams"
        :parse-result="parseResult"
        :table-attrs="tableAttrs"
      >
        <template #table-header>
          <div class="actions">
            <el-button size="mini" type="primary" @click="handleAddLevel">新增会员等级</el-button>
            <el-button size="mini" type="primary" @click="handleVipRuleDesc">VIP等级规则说明</el-button>
          </div>
        </template>
        <template #colMoney="{ row, column }">{{ row[column.property] | centsToYuan }}</template>
        <template #colPayoutEachDayMax="{ row }">{{ row.payout_each_day_max | centsToYuan }}</template>
        <template #colVipCount="{ row }">
          <el-button size="mini" type="text" @click="handleViewMembers(row)">{{ row.vip_count }}</el-button>
        </template>
        <template #colUpdatedAt="{ row }">{{
          row.updated_at ? new Date(row.updated_at).toLocaleString() : '--'
        }}</template>
        <template #colActions="{ row }">
          <el-button type="text" size="mini" @click="handleLevelConfig(row)">等级配置</el-button>
          <el-button type="text" size="mini" @click="handleBonusConfig(row)">红利配置</el-button>
        </template>
      </SchemaTablePage>
    </div>

    <!-- VIP会员列表弹窗 -->
    <el-dialog
      :visible.sync="vipMemberDialogVisible"
      :title="`VIP${selectedLevel.level} 会员列表`"
      class="page-dialog center-dialog-no-footer"
      width="1200px"
      center
      :close-on-click-modal="false"
      @closed="handleVipMemberDialogClosed"
    >
      <el-table :data="vipMemberList" border stripe size="small" :max-height="500" style="width: 100%">
        <el-table-column :resizable="false" prop="username" label="会员昵称" min-width="150"></el-table-column>
        <el-table-column :resizable="false" prop="gold" label="钱包余额" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.gold | centsToYuan }}
          </template>
        </el-table-column>
        <el-table-column :resizable="false" prop="agent_status" label="代理状态" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.agent_status === 0 ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column :resizable="false" prop="created_at" label="注册时间" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.created_at ? new Date(scope.row.created_at).toLocaleString() : '' }}
          </template>
        </el-table-column>
        <el-table-column :resizable="false" prop="login_at" label="最后登录时间" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.login_at ? new Date(scope.row.login_at).toLocaleString() : '' }}
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <el-pagination
          :current-page="vipMemberCurrentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="vipMemberPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="vipMemberTotal"
          @size-change="handleVipMemberSizeChange"
          @current-change="handleVipMemberCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <!-- 会员等级配置弹窗 -->
    <el-dialog
      :visible.sync="levelConfigDialogVisible"
      :title="selectedLevel.id ? `会员等级配置 - VIP${selectedLevel.level}` : '新增会员等级'"
      class="page-dialog center-dialog"
      width="480px"
      :close-on-click-modal="false"
      @closed="handleLevelConfigDialogClosed"
    >
      <el-form
        ref="levelConfigFormRef"
        :model="levelConfigForm"
        :rules="levelConfigRules"
        label-position="right"
        size="small"
        label-width="164px"
      >
        <el-row>
          <el-col v-if="!selectedLevel.id" :span="24">
            <el-form-item label="会员等级" prop="level">
              <el-select v-model="levelConfigForm.level" style="width: 100%" placeholder="请选择会员等级">
                <el-option
                  v-for="item in availableLevelOptionsForAdd"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="升级存款" prop="exp">
              <div style="display: flex; align-items: center">
                <el-input-number
                  v-model="levelConfigForm.exp"
                  placeholder="请输入"
                  :disabled="levelConfigForm.level === 0"
                  :controls="false"
                  :min="0"
                  style="flex: 1"
                ></el-input-number>
                <span class="amount-unit">{{ '' | amountUnit }}</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="保级打码量" prop="keep_lock_bet">
              <div style="display: flex; align-items: center">
                <el-input-number
                  v-model="levelConfigForm.keep_lock_bet"
                  :disabled="levelConfigForm.level === 0"
                  :controls="false"
                  :min="0"
                  style="flex: 1"
                  placeholder="请输入"
                ></el-input-number>
                <span class="amount-unit">{{ '' | amountUnit }}</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="升级打码量" prop="lock_bet">
              <div style="display: flex; align-items: center">
                <el-input-number
                  v-model="levelConfigForm.lock_bet"
                  :disabled="levelConfigForm.level === 0"
                  :controls="false"
                  :min="0"
                  style="flex: 1"
                  placeholder="请输入"
                ></el-input-number>
                <span class="amount-unit">{{ '' | amountUnit }}</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="单日提款限制(次)" prop="payout_each_day_times">
              <div style="display: flex; align-items: center">
                <el-input-number
                  v-model="levelConfigForm.payout_each_day_times"
                  :controls="false"
                  :min="0"
                  style="flex: 1"
                  placeholder="请输入"
                ></el-input-number>
                <span class="amount-unit">次</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="单日提款限额" prop="payout_each_day_max">
              <div style="display: flex; align-items: center">
                <el-input-number
                  v-model="levelConfigForm.payout_each_day_max"
                  :controls="false"
                  :min="0"
                  style="flex: 1"
                  placeholder="请输入"
                ></el-input-number>
                <span class="amount-unit">{{ '' | amountUnit }}</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="每日免手续费(笔数)" prop="payout_each_day_no_fee_count">
              <div style="display: flex; align-items: center">
                <el-input-number
                  v-model="levelConfigForm.payout_each_day_no_fee_count"
                  :controls="false"
                  :min="0"
                  style="flex: 1"
                  placeholder="请输入"
                ></el-input-number>
                <span class="amount-unit">次</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="levelConfigDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleLevelConfigSubmit">确认</el-button>
      </div>
    </el-dialog>

    <!-- 等级红利配置弹窗 -->
    <el-dialog
      :visible.sync="bonusConfigDialogVisible"
      :title="`等级红利配置 - VIP${selectedLevel.level}`"
      class="page-dialog center-dialog"
      width="720px"
      :close-on-click-modal="false"
      @closed="handleBonusConfigDialogClosed"
    >
      <el-form
        ref="bonusConfigFormRef"
        :model="bonusConfigForm"
        :rules="bonusConfigRules"
        label-position="right"
        size="small"
      >
        <!-- 每周红利 -->
        <div class="bonus-section">
          <div class="section-title">
            每周红利
            <el-switch
              v-model="bonusConfigForm.has_week_reward"
              :active-value="1"
              :inactive-value="2"
              style="margin-left: 10px"
            ></el-switch>
          </div>
          <el-row v-if="bonusConfigForm.has_week_reward === 1" :gutter="20">
            <el-col :span="24">
              <el-form-item label="每周红利" prop="week_reward">
                <div style="display: flex; align-items: center">
                  <el-input-number v-model="bonusConfigForm.week_reward" :controls="false" :min="0"></el-input-number>
                  <span class="amount-unit">{{ '' | amountUnit }}</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="发放条件: 近一周流水" prop="week_reward_need_bet">
                <div style="display: flex; align-items: center">
                  <el-input-number
                    v-model="bonusConfigForm.week_reward_need_bet"
                    :controls="false"
                    :min="0"
                  ></el-input-number>
                  <span class="amount-unit">{{ '' | amountUnit }}</span>
                </div>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="打码倍数" prop="week_reward_lock_multiple">
                <div style="display: flex; align-items: center">
                  <el-input-number
                    v-model="bonusConfigForm.week_reward_lock_multiple"
                    :controls="false"
                    :min="0"
                  ></el-input-number>
                  <span class="amount-unit">倍</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="有效期" prop="week_reward_limit_type">
                <div>
                  <el-radio-group v-model="bonusConfigForm.week_reward_limit_type">
                    <el-radio :label="1">按天</el-radio>
                    <el-radio :label="2">按小时</el-radio>
                  </el-radio-group>
                  <el-input-number
                    v-model="bonusConfigForm.week_reward_limit_value"
                    :controls="false"
                    :min="1"
                    style="margin-left: 20px; width: 120px"
                  ></el-input-number>
                  <span class="amount-unit">
                    {{ bonusConfigForm.week_reward_limit_type === 1 ? '天' : '小时' }}
                  </span>
                </div>
                <div style="color: #f56c6c; font-size: 12px">
                  注:所有VIP等级会同时修改有效期，已发放的红利不受修改影响
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 每月红利 -->
        <div class="bonus-section">
          <div class="section-title">
            每月红利
            <el-switch
              v-model="bonusConfigForm.has_month_reward"
              :active-value="1"
              :inactive-value="2"
              style="margin-left: 10px"
            ></el-switch>
          </div>
          <el-row v-if="bonusConfigForm.has_month_reward === 1" :gutter="20">
            <el-col :span="24">
              <el-form-item label="每月红利" prop="month_reward">
                <div style="display: flex; align-items: center">
                  <el-input-number v-model="bonusConfigForm.month_reward" :controls="false" :min="0"></el-input-number>
                  <span class="amount-unit">{{ '' | amountUnit }}</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="发放条件: 近一月流水" prop="month_reward_need_bet">
                <div style="display: flex; align-items: center">
                  <el-input-number
                    v-model="bonusConfigForm.month_reward_need_bet"
                    :controls="false"
                    :min="0"
                  ></el-input-number>
                  <span class="amount-unit">{{ '' | amountUnit }}</span>
                </div>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="打码倍数" prop="month_reward_lock_multiple">
                <div style="display: flex; align-items: center">
                  <el-input-number
                    v-model="bonusConfigForm.month_reward_lock_multiple"
                    :controls="false"
                    :min="0"
                  ></el-input-number>
                  <span style="margin-left: 10px; color: #606266">倍</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="有效期" prop="month_reward_limit_type">
                <div>
                  <el-radio-group v-model="bonusConfigForm.month_reward_limit_type">
                    <el-radio :label="1">按天</el-radio>
                    <el-radio :label="2">按小时</el-radio>
                  </el-radio-group>
                  <el-input-number
                    v-model="bonusConfigForm.month_reward_limit_value"
                    :controls="false"
                    :min="1"
                    style="margin-left: 20px; width: 120px"
                  ></el-input-number>
                  <span class="amount-unit">
                    {{ bonusConfigForm.month_reward_limit_type === 1 ? '天' : '小时' }}
                  </span>
                </div>
                <div style="color: #f56c6c; font-size: 12px">
                  注:所有VIP等级会同时修改有效期，已发放的红利不受修改影响
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 升级红利 -->
        <div class="bonus-section">
          <div class="section-title">
            升级红利
            <el-switch
              v-model="bonusConfigForm.has_reward"
              :active-value="1"
              :inactive-value="2"
              style="margin-left: 10px"
            ></el-switch>
          </div>
          <el-row v-if="bonusConfigForm.has_reward === 1" :gutter="20">
            <el-col :span="24">
              <el-form-item label="升级红利" prop="reward">
                <div style="display: flex; align-items: center">
                  <el-input-number v-model="bonusConfigForm.reward" :controls="false" :min="0"></el-input-number>
                  <span class="amount-unit">{{ '' | amountUnit }}</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="打码倍数" prop="reward_lock_multiple">
                <div style="display: flex; align-items: center">
                  <el-input-number
                    v-model="bonusConfigForm.reward_lock_multiple"
                    :controls="false"
                    :min="0"
                  ></el-input-number>
                  <span class="amount-unit">倍</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="有效期" prop="reward_is_forever">
                <div>
                  <el-radio-group v-model="bonusConfigForm.reward_is_forever">
                    <el-radio :label="1">永久有效</el-radio>
                    <el-radio :label="2">天</el-radio>
                    <el-radio :label="3">小时</el-radio>
                  </el-radio-group>
                  <el-input-number
                    v-if="bonusConfigForm.reward_is_forever !== 1"
                    v-model="bonusConfigForm.reward_limit_value"
                    :controls="false"
                    :min="1"
                    style="margin-left: 20px; width: 120px"
                  ></el-input-number>
                  <span v-if="bonusConfigForm.reward_is_forever !== 1" class="amount-unit">
                    {{ bonusConfigForm.reward_is_forever === 2 ? '天' : '小时' }}
                  </span>
                </div>
                <div style="color: #f56c6c; font-size: 12px">注:所有VIP等级会同时修改有效期</div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="bonusConfigDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleBonusConfigSubmit">确认</el-button>
      </div>
    </el-dialog>

    <!-- VIP等级规则说明弹窗 -->
    <el-dialog
      :visible.sync="vipRuleDescDialogVisible"
      title="VIP等级规则说明"
      class="page-dialog center-dialog"
      width="600px"
      :close-on-click-modal="false"
      @closed="handleVipRuleDescDialogClosed"
    >
      <el-form
        ref="vipRuleDescFormRef"
        :model="vipRuleDescForm"
        :rules="vipRuleDescRules"
        label-position="right"
        size="small"
      >
        <el-form-item label="规则说明">
          <el-input
            v-model="vipRuleDescForm.desc"
            type="textarea"
            :autosize="{ minRows: 8, maxRows: 16 }"
            placeholder="请输入VIP等级规则说明"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="vipRuleDescDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleVipRuleDescSubmit">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 引入API
import {
  createVip,
  getPlayerVipLevelList,
  getVipDetail,
  getVipList,
  getVipRuleDesc,
  updateBonusData,
  updateVip,
  updateVipRuleDesc,
} from '@/api/member/vip'
import SchemaTablePage from '@/components/SchemaTablePage'
import { centsToYuan, centsToYuanNumber, yuanToCents } from '@/utils/amount.js'

export default {
  name: 'MemberLevel',
  components: { SchemaTablePage },
  data() {
    return {
      // 会员等级列表数据
      memberLevelList: [],
      tableAttrs: {},
      defaultQuery: {},
      tableColumns: [
        { prop: 'level', label: '会员等级', minWidth: 80, resizable: false },
        { prop: 'exp', label: '升级存款', minWidth: 100, resizable: false, slot: 'colMoney' },
        { prop: 'keep_lock_bet', label: '保级打码量', minWidth: 100, resizable: false, slot: 'colMoney' },
        { prop: 'lock_bet', label: '升级打码量', minWidth: 100, resizable: false, slot: 'colMoney' },
        { prop: 'reward', label: '升级红利', minWidth: 100, resizable: false, slot: 'colMoney' },
        { prop: 'week_reward', label: '每周红利', minWidth: 100, resizable: false, slot: 'colMoney' },
        { prop: 'payout_each_day_times', label: '单日提款限制(次)', minWidth: 120, resizable: false },
        {
          prop: 'payout_each_day_max',
          label: '单日提款限额',
          minWidth: 120,
          resizable: false,
          slot: 'colPayoutEachDayMax',
        },
        { prop: 'vip_count', label: '会员数量', minWidth: 100, resizable: false, slot: 'colVipCount' },
        { prop: 'last_operator', label: '最后操作人', minWidth: 120, resizable: false },
        { prop: 'updated_at', label: '最后操作时间', minWidth: 140, resizable: false, slot: 'colUpdatedAt' },
        { fixed: 'right', label: '操作', width: 140, align: 'center', resizable: false, slot: 'colActions' },
      ],

      // 选中的等级
      selectedLevel: {},

      // VIP会员列表弹窗
      vipMemberDialogVisible: false,
      vipMemberList: [],
      vipMemberCurrentPage: 1,
      vipMemberPageSize: 10,
      vipMemberTotal: 0,

      // 会员等级配置弹窗
      levelConfigDialogVisible: false,
      levelConfigForm: {
        level: 0, // 会员等级
        exp: 0, // 升级存款
        keep_lock_bet: 0, // 保级打码量
        lock_bet: 0, // 升级打码量
        payout_each_day_times: 0, // 单日提款限制
        payout_each_day_max: 0, // 单日提款限额
        payout_each_day_no_fee_count: 0, // 单日无手续费提款次数
      },
      levelConfigRules: {
        level: [{ required: true, message: '请选择会员等级', trigger: 'change' }],
        exp: [
          { required: true, message: '请输入升级存款', trigger: 'blur' },
          { type: 'number', min: 0, message: '升级存款不能为负数', trigger: 'blur' },
        ],
        keep_lock_bet: [
          { required: true, message: '请输入保级打码量', trigger: 'blur' },
          { type: 'number', min: 0, message: '保级打码量不能为负数', trigger: 'blur' },
        ],
        lock_bet: [
          { required: true, message: '请输入升级打码量', trigger: 'blur' },
          { type: 'number', min: 0, message: '升级打码量不能为负数', trigger: 'blur' },
        ],
        payout_each_day_times: [
          { required: true, message: '请输入单日提款限制', trigger: 'blur' },
          { type: 'number', min: 0, message: '单日提款限制不能为负数', trigger: 'blur' },
        ],
        payout_each_day_max: [
          { required: true, message: '请输入单日提款限额', trigger: 'blur' },
          { type: 'number', min: 0, message: '单日提款限额不能为负数', trigger: 'blur' },
        ],
        payout_each_day_no_fee_count: [
          { required: true, message: '请输入单日无手续费提款次数', trigger: 'blur' },
          { type: 'number', min: 0, message: '单日无手续费提款次数不能为负数', trigger: 'blur' },
        ],
      },

      // 等级红利配置弹窗
      bonusConfigDialogVisible: false,
      bonusConfigForm: {
        // 每周红利
        has_week_reward: 2, // 1=有，2=没有
        week_reward: 0, // 每周红利金额
        week_reward_need_bet: 0, // 每周奖励需要流水
        week_reward_limit_type: 2, // 1=天，2=小时
        week_reward_limit_value: 24, // 每周奖励有效期值
        week_reward_lock_multiple: 1, // 每周奖励打码倍数

        // 每月红利
        has_month_reward: 2, // 1=有，2=没有
        month_reward: 0, // 每月红利金额
        month_reward_need_bet: 0, // 每月奖励需要流水
        month_reward_limit_type: 1, // 1=天，2=小时
        month_reward_limit_value: 30, // 每月奖励有效期值
        month_reward_lock_multiple: 1, // 每月奖励打码倍数

        // 升级红利
        has_reward: 2, // 1=有，2=没有
        reward: 0, // 升级红利金额
        reward_is_forever: 1, // 1=永久有效，2=天，3=小时
        reward_limit_value: 30, // 升级奖励有效期值
        reward_lock_multiple: 1, // 升级奖励打码倍数
      },
      bonusConfigRules: {
        // 每周红利验证
        week_reward: [
          { required: true, message: '请输入每周红利', trigger: 'blur' },
          { type: 'number', min: 0, message: '每周红利不能为负数', trigger: 'blur' },
        ],
        week_reward_need_bet: [
          { required: true, message: '请输入发放条件: 近一周流水', trigger: 'blur' },
          { type: 'number', min: 0, message: '发放条件不能为负数', trigger: 'blur' },
        ],
        week_reward_limit_type: [{ required: true, message: '请选择有效期类型', trigger: 'change' }],
        week_reward_limit_value: [
          { required: true, message: '请输入有效期值', trigger: 'blur' },
          { type: 'number', min: 1, message: '有效期值不能小于1', trigger: 'blur' },
        ],
        week_reward_lock_multiple: [
          { required: true, message: '请输入打码倍数', trigger: 'blur' },
          { type: 'number', min: 0, message: '打码倍数不能为负数', trigger: 'blur' },
        ],

        // 每月红利验证
        month_reward: [
          { required: true, message: '请输入每月红利', trigger: 'blur' },
          { type: 'number', min: 0, message: '每月红利不能为负数', trigger: 'blur' },
        ],
        month_reward_need_bet: [
          { required: true, message: '请输入发放条件: 近一月流水', trigger: 'blur' },
          { type: 'number', min: 0, message: '发放条件不能为负数', trigger: 'blur' },
        ],
        month_reward_limit_type: [{ required: true, message: '请选择有效期类型', trigger: 'change' }],
        month_reward_limit_value: [
          { required: true, message: '请输入有效期值', trigger: 'blur' },
          { type: 'number', min: 1, message: '有效期值不能小于1', trigger: 'blur' },
        ],
        month_reward_lock_multiple: [
          { required: true, message: '请输入打码倍数', trigger: 'blur' },
          { type: 'number', min: 0, message: '打码倍数不能为负数', trigger: 'blur' },
        ],

        // 升级红利验证
        reward: [
          { required: true, message: '请输入升级红利', trigger: 'blur' },
          { type: 'number', min: 0, message: '升级红利不能为负数', trigger: 'blur' },
        ],
        reward_is_forever: [{ required: true, message: '请选择有效期类型', trigger: 'change' }],
        reward_limit_value: [
          { required: true, message: '请输入有效期值', trigger: 'blur' },
          { type: 'number', min: 1, message: '有效期值不能小于1', trigger: 'blur' },
        ],
        reward_lock_multiple: [
          { required: true, message: '请输入打码倍数', trigger: 'blur' },
          { type: 'number', min: 0, message: '打码倍数不能为负数', trigger: 'blur' },
        ],
      },

      // VIP等级规则说明弹窗
      vipRuleDescDialogVisible: false,
      vipRuleDescForm: {
        desc: '',
      },
      vipRuleDescRules: {
        desc: [{ required: true, message: '请输入规则说明', trigger: 'blur' }],
      },
    }
  },
  computed: {
    availableLevelOptionsForAdd() {
      const existingLevels = (this.memberLevelList || []).map(row => row.level)
      return Array.from({ length: 11 }, (_, i) => i)
        .filter(level => !existingLevels.includes(level))
        .map(value => ({ label: `VIP${value}`, value }))
    },
  },
  mounted() {
    this.$refs.tablePageRef?.reload?.()
  },
  methods: {
    centsToYuan,
    request(params) {
      return getVipList(params)
    },
    buildParams({ page, limit }) {
      return {
        page,
        page_size: limit,
      }
    },
    parseResult(res) {
      const list = res?.data?.list || []
      const total = res?.data?.total || 0
      // 保留给页面内其它逻辑复用（例如：新增等级选项）
      this.memberLevelList = list
      return { list, total }
    },

    // 查看会员列表
    async handleViewMembers(row) {
      try {
        this.selectedLevel = row
        this.vipMemberDialogVisible = true
        // 调用API获取实际的VIP会员列表
        const res = await getPlayerVipLevelList({
          level: row.level,
          page: this.vipMemberCurrentPage,
          page_size: this.vipMemberPageSize,
        })
        this.vipMemberList = res?.data?.list || []
        this.vipMemberTotal = res?.data?.total || 0
      } catch (error) {
        console.error(error)
        this.$message.error('获取VIP会员列表失败')
      }
    },

    // 处理VIP会员列表弹窗关闭
    handleVipMemberDialogClosed() {
      this.selectedLevel = {}
      this.vipMemberList = []
      this.vipMemberTotal = 0
      this.vipMemberCurrentPage = 1
    },

    // 处理VIP会员列表分页大小变化
    handleVipMemberSizeChange(size) {
      this.vipMemberPageSize = size
      this.vipMemberCurrentPage = 1
      this.handleViewMembers(this.selectedLevel)
    },

    // 处理VIP会员列表当前页码变化
    handleVipMemberCurrentChange(page) {
      this.vipMemberCurrentPage = page
      this.handleViewMembers(this.selectedLevel)
    },

    // 会员等级配置
    async handleLevelConfig(row) {
      try {
        this.selectedLevel = row
        // 调用API获取完整的VIP等级详情
        const res = await getVipDetail({ id: row.id })
        const detail = res?.data || {}
        this.levelConfigForm = {
          level: detail.level,
          exp: centsToYuanNumber(detail.exp),
          keep_lock_bet: centsToYuanNumber(detail.keep_lock_bet),
          lock_bet: centsToYuanNumber(detail.lock_bet),
          payout_each_day_times: detail.payout_each_day_times,
          payout_each_day_max: centsToYuanNumber(detail.payout_each_day_max),
          payout_each_day_no_fee_count: detail.payout_each_day_no_fee_count || 0,
        }
        this.levelConfigDialogVisible = true
      } catch (error) {
        this.$message.error('获取VIP等级详情失败')
        console.error(error)
      }
    },

    // 处理等级配置弹窗关闭
    handleLevelConfigDialogClosed() {
      this.selectedLevel = {}
      this.$refs.levelConfigFormRef?.resetFields()
    },

    // 提交等级配置
    async handleLevelConfigSubmit() {
      try {
        const valid = await this.$refs.levelConfigFormRef.validate()
        if (valid) {
          if (this.selectedLevel.id) {
            // 编辑操作
            await updateVip({
              id: this.selectedLevel.id,
              ...this.levelConfigForm,
              exp: yuanToCents(this.levelConfigForm.exp),
              keep_lock_bet: yuanToCents(this.levelConfigForm.keep_lock_bet),
              lock_bet: yuanToCents(this.levelConfigForm.lock_bet),
              payout_each_day_max: yuanToCents(this.levelConfigForm.payout_each_day_max),
            })
          } else {
            // 新增操作
            await createVip({
              ...this.levelConfigForm,
              exp: yuanToCents(this.levelConfigForm.exp),
              keep_lock_bet: yuanToCents(this.levelConfigForm.keep_lock_bet),
              lock_bet: yuanToCents(this.levelConfigForm.lock_bet),
              payout_each_day_max: yuanToCents(this.levelConfigForm.payout_each_day_max),
            })
          }
          this.$message.success('保存成功')
          this.levelConfigDialogVisible = false
          this.$refs.tablePageRef?.reload?.()
        }
      } catch (error) {
        // this.$message.error('保存等级配置失败: ' + error.message)
        console.error('保存等级配置失败', error)
      }
    },

    // 等级红利配置
    async handleBonusConfig(row) {
      try {
        this.selectedLevel = row
        // 调用API获取完整的VIP等级详情
        const res = await getVipDetail({ id: row.id })
        const detail = res?.data || {}
        this.bonusConfigForm = {
          // 每周红利
          has_week_reward: detail.has_week_reward || 2,
          week_reward: centsToYuanNumber(detail.week_reward) || 0,
          week_reward_need_bet: centsToYuanNumber(detail.week_reward_need_bet) || 0,
          week_reward_limit_type: detail.week_reward_limit_type || 2,
          week_reward_limit_value: detail.week_reward_limit_value || 24,
          week_reward_lock_multiple: detail.week_reward_lock_multiple || 1,

          // 每月红利
          has_month_reward: detail.has_month_reward || 2,
          month_reward: centsToYuanNumber(detail.month_reward) || 0,
          month_reward_need_bet: centsToYuanNumber(detail.month_reward_need_bet) || 0,
          month_reward_limit_type: detail.month_reward_limit_type || 1,
          month_reward_limit_value: detail.month_reward_limit_value || 30,
          month_reward_lock_multiple: detail.month_reward_lock_multiple || 1,

          // 升级红利
          has_reward: detail.has_reward || 2,
          reward: centsToYuanNumber(detail.reward) || 0,
          reward_is_forever: detail.reward_is_forever || 1,
          reward_limit_value: detail.reward_limit_value || 30,
          reward_lock_multiple: detail.reward_lock_multiple || 1,
        }
        this.bonusConfigDialogVisible = true
      } catch (error) {
        this.$message.error('获取VIP等级详情失败')
        console.error(error)
      }
    },

    // 处理红利配置弹窗关闭
    handleBonusConfigDialogClosed() {
      this.selectedLevel = {}
      this.$refs.bonusConfigFormRef?.resetFields()
    },

    // 提交红利配置
    async handleBonusConfigSubmit() {
      try {
        const valid = await this.$refs.bonusConfigFormRef.validate()
        if (valid) {
          await updateBonusData({
            id: this.selectedLevel.id,
            ...this.bonusConfigForm,
            week_reward: yuanToCents(this.bonusConfigForm.week_reward),
            month_reward: yuanToCents(this.bonusConfigForm.month_reward),
            week_reward_need_bet: yuanToCents(this.bonusConfigForm.week_reward_need_bet),
            month_reward_need_bet: yuanToCents(this.bonusConfigForm.month_reward_need_bet),
            reward: yuanToCents(this.bonusConfigForm.reward),
          })
          this.$message.success('保存成功')
          this.bonusConfigDialogVisible = false
          this.$refs.tablePageRef?.reload?.()
        }
      } catch (error) {
        this.$message.error('保存红利配置失败')
      }
    },

    // 处理VIP等级规则说明
    async handleVipRuleDesc() {
      try {
        // 这里可以调用API获取当前的规则说明
        // 暂时使用mock数据模拟
        // const response = await memberMock.getVipRuleDesc();
        const response = await getVipRuleDesc()
        this.vipRuleDescForm.desc = response.data.desc || ''
      } catch (error) {
        this.$message.error('获取规则说明失败')
      }
      this.vipRuleDescDialogVisible = true
    },

    // 提交VIP等级规则说明
    async handleVipRuleDescSubmit() {
      try {
        const valid = await this.$refs.vipRuleDescFormRef.validate()
        if (valid) {
          // const response = await memberMock.saveVipRuleDesc(this.vipRuleDescForm);
          await updateVipRuleDesc(this.vipRuleDescForm)
          this.$message.success('保存成功')
          this.vipRuleDescDialogVisible = false
        }
      } catch (error) {
        this.$message.error('保存规则说明失败')
      }
    },

    // 处理VIP等级规则说明弹窗关闭
    handleVipRuleDescDialogClosed() {
      this.$refs.vipRuleDescFormRef?.resetFields()
    },

    // 新增会员等级
    handleAddLevel() {
      this.selectedLevel = {}
      const firstAvailable = this.availableLevelOptionsForAdd[0]
      this.levelConfigForm = {
        level: firstAvailable != null ? firstAvailable.value : 0,
        exp: 0,
        keep_lock_bet: 0,
        lock_bet: 0,
        payout_each_day_times: undefined,
        payout_each_day_max: undefined,
        payout_each_day_no_fee_count: undefined,
      }
      this.levelConfigDialogVisible = true
    },

    // 分页由 SchemaTablePage 内置处理
  },
}
</script>

<style lang="scss" scoped>
.bonus-section {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  &:last-child {
    margin-bottom: 0;
  }
}
.bonus-section {
  .section-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #303133;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.validity-container {
  display: flex;
  align-items: center;
}

.amount-unit {
  min-width: 40px;
  text-align: left;
  margin-left: 10px;
  color: #606266;
}
</style>
